import { Switch } from "@mui/material";
import {
  DatePickerComponent,
  TimePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import Successfull from "../../../Create_Assessment/create_successfull/Successfull";
import axios from "../../../../../axios";
import { toast } from "react-toastify";

const DraftPublish = ({
  setClick,
  questions,
  assessmentDetails,
  setAssessmentDetails,
  isScheduledEditing,
}) => {
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [lectureDate, setLectureDate] = useState();

  const [success, setSuccess] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };

  const [studentList, setStudentList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [lectures, setLectures] = useState();
  const [minTime, setMinTime] = useState(new Date()); // Initialize minTime with the current time

  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  useEffect(() => {
    let students = [];
    let existingStudentsList = [];
    const getStudentList = async () => {
      if (!timeTableSessionId) {
        return;
      }
      try {
        let res = await axios.get(
          `/api/v1/school/student/getList?standardId=${assessmentDetails?.standard_id?.id}&sectionId=${assessmentDetails?.section_id?.id}&timetableSession=${timeTableSessionId}`,
        );

        res &&
          res.data.data.map((student) =>
            students.push({ value: student.id, label: student.name }),
          );

        let existingStudents = await axios.get(
          `/api/v1/assessment/studentAssessment/getByAssessmentId/${assessmentDetails?.id}?isOnlyList=true`,
        );
        existingStudents &&
          existingStudents.data.data.map((student) =>
            existingStudentsList.push({
              value: student.student_id?.id,
              label: student.student_id?.name,
            }),
          );

        setSelectedList(existingStudentsList);

        setStudentList(students);
      } catch (error) {
        console.log(error);
      }

      // try {
      //   if (assessmentDetails?.deadline) {
      //     let lectures = await axios.get(
      //       `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${assessmentDetails?.standard_id?.id}/sectionId/${assessmentDetails?.section_id?.id}/timetableSessionId/${timeTableSessionId}/subjectId/${assessmentDetails?.subject_id?.id}/date/${assessmentDetails?.deadline}`
      //     );
      //     lectures && setLectures(lectures?.data?.data[0].lectures);
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
    };

    getStudentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStudentSelection = (selected) => {
    setSelectedList(selected);
  };

  useEffect(() => {
    const getLiveLectureList = async () => {
      if (!academicYearId || !timeTableSessionId) {
        toast.error(
          "These are no allocations set for your login. Please contact school admin for the assistance.",
        );
        return;
      }
      try {
        setLectures([]);
        if (assessmentDetails?.deadline) {
          let lectures = await axios.get(
            `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${assessmentDetails?.standard_id?.id}/sectionId/${assessmentDetails?.section_id?.id}/timetableSessionId/${timeTableSessionId}/subjectId/${assessmentDetails?.subject_id?.id}/date/${lectureDate}`,
          );
          lectures && setLectures(lectures?.data?.data[0].lectures);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getLiveLectureList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureDate]);

  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }
  const dateHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate() + 1;
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${year}-${month}-${day}`;
    return outputDateString;
  };
  const dateHelper2 = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${year}-${month}-${day}`;
    return outputDateString;
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const outputDateString = `${hours}:${minutes}`;
    return outputDateString;
  };

  const calculateMinTime = () => {
    if (assessmentDetails?.schedule_date) {
      const startDate = new Date(assessmentDetails.schedule_date);
      if (today.getDate() === startDate.getDate()) {
        startDate.setTime(today.getTime() + 30 * 60000);
      } else {
        startDate.setHours(0, 0, 0, 0);
      }
      return startDate;
    } else {
      // If no date is selected, start from current time + 30 minutes
      const now = new Date();
      now.setMinutes(now.getMinutes() + 30);
      return now;
    }
  };

  const handleUpdateAssessment = async () => {
    setIsInProgress(true);
    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id: null,
      assessmentTypeId: assessmentDetails.assessmentTypeId,
      assessmentEventId: assessmentDetails.assessmentEventId,
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "published",
      total_duration: assessmentDetails.total_duration,
      deadline: assessmentDetails.deadline,
      schedule_date: assessmentDetails.schedule_date,
      schedule_time: assessmentDetails.schedule_time,
      add_to_live_session: assessmentDetails.add_to_live_session,
      questions: questions,
    };

    try {
      let res = await axios.put(
        `/api/v1/assessment/update/${assessmentDetails?.id}`,
        newAssessment,
      );

      if (res) {
        let students_id = [];
        for (const student of selectedList) {
          students_id.push(student.value);
        }
        let newStudentAssessment = {
          teacher_id: assessmentDetails?.teacher_id,
          student_id: students_id,
          status: "pending",
          deadline: assessmentDetails?.deadline,
        };
        let studentRes = await axios.post(
          `/api/v1/assessment/${res?.data?.data?.id}/studentAssessment/addStudents`,
          newStudentAssessment,
        );

        studentRes && setSuccess(!success);
      }
    } catch (error) {
      console.log(error);
    }
    setIsInProgress(false);
  };
  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadline = assessmentDetails?.schedule_date;
  console.log(deadline);
  if (deadline) {
    var minLiveSessionDate = new Date(deadline);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 6);

    var maxLiveSessionDate = new Date(deadline);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }
  return (
    <>
      {!success && (
        <div className="publish_transprant_body1">
          <div className=" p-4 publish_white_containerPre">
            <img
              src="/images/cross-circle3.svg"
              className="subPrereadClosetBtn"
              alt=""
              onClick={(e) => setClick(false)}
            />
            <h5 className="publish_header">Publish</h5>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.subject_id?.name}
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.standard_id?.name}
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.section_id?.name}
            </div>
            {/* <div className=" col-12 m-0 p-0 px-2 EnterDeadlinePreread">
              <DateTimePickerComponent
                placeholder="deadline"
                id="datepicker"
                min={minDateTime} // Set the minimum date to today
               // format='yyyy-MM-dd'
                value={assessmentDetails?.deadline}
                onChange={(e) =>
                  setAssessmentDetails({
                    ...assessmentDetails,
                    //deadline: dateHelper(e.target.value),
                    deadline: e.target.value,
                  })
                }
              />
            </div> */}

            <div className="my-3">
              <MultiSelect
                options={studentList}
                value={selectedList}
                onChange={handleStudentSelection}
                labelledBy="Select"
                className="custom-multiselect"
              />
            </div>

            <div className="btn_containers">
              <div className="toggle_btn">
                <div className="schedule_btns">
                  <span>Schedule</span>
                  <label className="switch">
                    <Switch
                      checked={checked}
                      onChange={(event) => {
                        setChecked(event.target.checked);
                        setChecked1(false);
                        setAssessmentDetails({
                          ...assessmentDetails,
                          schedule_date: null,
                          schedule_time: null,
                        });
                      }}
                    />
                  </label>
                </div>
                {checked && (
                  <>
                    {/* id css define in createPublishPreRead.css */}
                    <div className=" schedule_box ">
                      <DatePickerComponent
                        allowEdit={false}
                        min={today}
                        isDateDisabled={disablePastDates}
                        id="datepicker"
                        placeholder="Scheduled date"
                        value={assessmentDetails?.schedule_date}
                        onChange={(e) => {
                          if (!e.target.value) {
                            setAssessmentDetails({
                              ...assessmentDetails,
                              schedule_date: "",
                            });
                            setChecked1(false);
                          } else {
                            setAssessmentDetails({
                              ...assessmentDetails,
                              schedule_date: dateHelper2(e.target.value),
                              deadline: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                    <div className="schedule_box  ">
                      <TimePickerComponent
                        min={calculateMinTime()}
                        isDateDisabled={disablePastDates}
                        id="timepicker"
                        placeholder="Scheduled time"
                        onChange={(e) =>
                          setAssessmentDetails({
                            ...assessmentDetails,
                            schedule_time: timeHelper(e.target.value),
                          })
                        }
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="toggle_btn">
                <div className=" schedule_btns p-1 ml-1">
                  {deadline ? (
                    <label className="pt-1 mb-0">
                      <DatePickerComponent
                        id="datepicker"
                        placeholder="Add to Lecture Session"
                        width={230}
                        min={minLiveSessionDate}
                        max={maxLiveSessionDate}
                        allowEdit={false}
                        onChange={(e) => {
                          if (!e.target.value) {
                            setLectureDate(null);
                          } else {
                            setChecked1(true);
                            setLectureDate(formatDate(e.target.value));
                          }
                        }}
                      />
                    </label>
                  ) : (
                    <>
                      <label className="deadlineNotSelect pb-1 pl-1">
                        Add to Lecture Session
                      </label>
                      <img
                        src="/images/calIconDow.png"
                        alt=""
                        className="calDow"
                      />
                    </>
                  )}
                </div>
                {checked1 && (
                  <div className="schedule_box border-0 p-0 ml-1 mt-3">
                    <select
                      className="form-select col-12 py-2 m-0  "
                      id="Schedule_sesion"
                      onChange={(e) =>
                        setAssessmentDetails({
                          ...assessmentDetails,
                          add_to_live_session: {
                            lecture_id: e.target.value,
                            date: convertDateFormat(
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("date"),
                            ),
                          },
                        })
                      }
                    >
                      <option selected>Select Lecture</option>
                      {lectures?.length > 0 &&
                        lectures?.map((lecture, index) => (
                          <option
                            key={index}
                            value={lecture.id}
                            date={lecture.date}
                          >
                            {lecture.name}, {lecture.date},{" "}
                            {convertTimeStringToAMPM(lecture.start_time)}-
                            {convertTimeStringToAMPM(lecture.end_time)}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
              </div>
            </div>

            <div className="  publish_btn_box">
              <button
                disabled={
                  !assessmentDetails.schedule_date ||
                  !assessmentDetails.schedule_time ||
                  !selectedList.length > 0
                }
                className="btn publish_btn"
                onClick={handleUpdateAssessment}
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      )}
      {success && <Successfull setSuccess={setSuccess} />}
      {!success && isInProgress && (
        <div className="loader_bg">
          <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
        </div>
      )}
    </>
  );
};

export default DraftPublish;
